export const defaultOpts = {
  buffer: 50,
  delay: 0,
  duration: 250,
  interval: 100,
  slideTop: '-150px'
}
